import { BaseType } from '../repositories/base.repository'
import { FundingCode } from './data.model'

export const BRANCH_STATUS = [
  'WORKFLOW_INITIAL',
  'WORKFLOW_UPLOAD_PROCESSED',
  'WORKFLOW_IN_REVIEW',
  'WORKFLOW_EDITING_CONFLICTS',
  'WORKFLOW_MERGING',
  'WORKFLOW_FINISHED',
] as const
export type BranchStatus = (typeof BRANCH_STATUS)[number]

export const BRANCH_PROGRESS_STATE = [
  'UPLOAD_UNVALIDATED',
  'UPLOAD_VALIDATED',
  'UPLOAD_PROCESSING',
  'UPLOAD_PROCESSED',

  'ADDRESS_VALIDATION_STARTED',
  'ADDRESS_VALIDATION_DUPLICATE_CHECKED',
  'ADDRESS_VALIDATION_ADDRESS_CHECKED',
  'ADDRESS_VALIDATION_REVALIDATION_CHECKED',
  'ADDRESS_VALIDATION_COMPLETED',

  'UPLOAD_FAILED',
] as const
export type BranchProgressState = (typeof BRANCH_PROGRESS_STATE)[number]

export const ADDRESS_VALIDATION_IN_PROGRESS_STATES: BranchProgressState[] = [
  'ADDRESS_VALIDATION_STARTED',
  'ADDRESS_VALIDATION_DUPLICATE_CHECKED',
  'ADDRESS_VALIDATION_ADDRESS_CHECKED',
  'ADDRESS_VALIDATION_REVALIDATION_CHECKED',
]

export const BRANCH_SOURCES = [
  'project-sponsor',
  'planning-gu',
  'planning-gue',
  'construction-gu',
  'construction-gue',
  'oew-bb',
] as const
export type BranchSource = (typeof BRANCH_SOURCES)[number]

export const BRANCH_FILE_TYPES = ['hkbw'] as const
export type BranchFileType = (typeof BRANCH_FILE_TYPES)[number]

export const BRANCH_REASONS = ['initial', 'update'] as const
export type BranchReason = (typeof BRANCH_REASONS)[number]

export const FAILURE_REASON = [
  'UPLOAD_VALIDATION_FAILED',
  'UPLOAD_VALIDATION_DATA_FAILED',
  'ADDRESS_VALIDATION_FAILED',
  'ADDRESS_VALIDATION_REQUESTED',
  'GUARDDUTY_SCAN_FAILED',
  'INVALID_FILE_EXTENSION',
  'INVALID_CONTENT_TYPE',
  'INVALID_ENCODING',
  'INVALID_CSV_FORMAT',
  'EMPTY_FILE',
  'MISSING_DATA_ROWS',
  'INCONSISTENT_COLUMNS',
  'DUPLICATE_FILE_HASH',
  'ADDRESS_STORAGE_FAILED',
] as const
export type FailureReason = (typeof FAILURE_REASON)[number]

export type ProgressFailureReason = {
  error: FailureReason
  message?: string
}
export type ValidationFailureReason = {
  error_count: number
  pre_signed_url: string
}

export type Branch = BaseType & {
  createdAt: string
  createdBy: string
  updatedAt: string

  type: BranchFileType
  fundingCode: FundingCode
  mevId?: number // api don't send this attribute if no mevId given
  note: string
  reason: BranchReason
  source: BranchSource
  state: BranchStatus
  processState: BranchProgressState
  processFailureReason?: ProgressFailureReason

  addressCount: string
  unverifiedAddresses: number
  conflictAddresses: number
  duplicateWithChanges: number
  duplicateInCsv: number
  newAddresses: number
}
